import { get, find } from 'lodash';

export const getCardMethod = (settings) =>
  find(get(settings, 'payments.methods'), { id: 'card' });
export const getCardGateway = (settings) =>
  get(getCardMethod(settings), 'gateway');
export const getGateway = (settings, id) =>
  find(get(settings, 'payments.gateways'), { id });
